export interface EssenceInput {
  essence_type: string;
  tier: string;
}

export interface ForgePreview {
  weapon_type: string;
  base_damage: number;
  weight: number;
  durability: number;
  special_ability: string;
  visual_seed: number;
  traits: string[];
}

export interface ForgedWeapon extends ForgePreview {
  id?: string;
  name?: string;
  generation?: number;
  soulbound?: boolean;
}

export function forgePreviewPayload(essences: EssenceInput[]) {
  if (essences.length !== 3) throw new Error("The Anvil requires exactly three Essences.");
  return { essences };
}

function authHeaders(token: string) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json"
  };
}

async function readJson<T>(response: Response): Promise<T> {
  const payload = await response.json() as T & { error?: { message?: string } };
  if (!response.ok) throw new Error(payload.error?.message ?? "The Anvil rejected the ritual.");
  return payload;
}

export async function requestForgePreview(apiBase: string, token: string, essences: EssenceInput[]) {
  const { essences: payload } = forgePreviewPayload(essences);
  const query = encodeURIComponent(JSON.stringify(payload));
  const response = await fetch(`${apiBase}/forge/preview?essences=${query}`, {
    headers: authHeaders(token)
  });
  return readJson<{ preview: ForgePreview }>(response);
}

export async function requestForgeWeapon(apiBase: string, token: string, essences: EssenceInput[], weaponName: string) {
  const payload = forgePreviewPayload(essences);
  const response = await fetch(`${apiBase}/forge/weapon`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ ...payload, weapon_name: weaponName })
  });
  return readJson<{ weapon: ForgedWeapon }>(response);
}

export async function requestReforge(apiBase: string, token: string, inventoryId: string, essence: EssenceInput) {
  const response = await fetch(`${apiBase}/forge/reforge`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ inventory_id: inventoryId, essence })
  });
  return readJson<{ weapon: ForgedWeapon; forge_stones: number }>(response);
}
